// extracted by mini-css-extract-plugin
module.exports = {"partList":"PartList_partList__1lOv-","partItem":"PartList_partItem__345rp","partItemSelected":"PartList_partItemSelected__3F8GB"};